import type { IReporter } from './IReporter';
import type { RunnerOptions } from '../runOptions';
import type { ExecutionList } from '../runners/TestPlanRunner';
import type { TestRunStatusTestResult } from '../testRunStatus';

/* eslint-disable no-console */
class JsonReporter implements IReporter {
    constructor(private readonly options: RunnerOptions) {
    }

    public onTestStarted(test: TestRunStatusTestResult, workerId: number) {
        const event = {
            name: 'testStarted',
            data: {
                test,
                workerId,
            },
        };

        console.log(JSON.stringify(event));
    }

    public onTestFinished(test: TestRunStatusTestResult, workerId: number) {
        const event = {
            name: 'testFinished',
            data: {
                test,
                workerId,
            },
        };

        console.log(JSON.stringify(event));
    }

    public onTestPlanStarted(beforeTests: ExecutionList, tests: ExecutionList, afterTests: ExecutionList, testPlanName: string, executionId: string) {
        const event = {
            name: 'suiteStarted',
            data: {
                projectId: this.options.project,
                executionId,
            },
        };

        console.log(JSON.stringify(event));
    }

    public onTestPlanFinished(testResults: { [resultId: string]: TestRunStatusTestResult }) {
        const event = {
            name: 'suiteFinished',
            data: {
                testResults,
            },
        };

        console.log(JSON.stringify(event));
    }
}

export const Reporter = JsonReporter;
